// extracted by mini-css-extract-plugin
export var editButton = "_og-0";